var isType = require('./isType');

module.exports = function isInterface(x) {
  return isType(x) && ( x.meta.kind === 'interface' );
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isInterface.js
// module id = 423
// module chunks = 0